import React from 'react';
import Layout from 'layouts/Main';
import ForgotPassword from './ForgotPassword';

const title = 'Forgot Password';

function action() {
  return {
    routeName: 'forgotPassword',
    chunks: ['forgot-password'],
    title,
    component: (
      <Layout>
        <ForgotPassword title={title} />
      </Layout>
    ),
  };
}

export default action;
